module.exports = `:root {
  --primitiveColorNeutral0: #000000;
  --primitiveColorNeutral360: #4b575f;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorPrimary610: #e86d1f;
  --primitiveColorPrimary720: #f8971d;
  --primitiveColorPrimary830: #ffc425;
  --primitiveColorGreen620: #78a22f;
  --primitiveColorGreen790: #c1cd23;
}
`;